<template>
  <div
    class="d-flex align-items-center flex-fill"
    v-if="data.groupName === 'domain'"
    v-click-outside="closeForm"
  >
    <b-badge
      v-if="data[td.key].tag"
      class="d-flex align-items-center ml-auto mr-0"
      href="#"
      @click.prevent="openForm"
      :variant="getBadgeVariant(data[td.key].tag)"
    >
      {{ data[td.key].tag }}
      <svg-icon icon="pencil" class="icon-sm ml-2" style="margin-right: -3px" />
    </b-badge>
    <button class="ml-auto btn btn-sm mr-0 btn-danger" v-else @click="openForm">
      Add tag
    </button>
    <transition name="slide-from-right">
      <div
        v-if="tagForm"
        class="tag-form pr-6 pl-3 d-flex align-items-center justify-content-center"
      >
        <a class="tag-form-close" href="#" @click.prevent="closeForm">
          <svg-icon icon="chevron-right" class="icon-sm" />
        </a>
        <b-badge
          v-for="tag in tags"
          :key="tag.id"
          href="#"
          :variant="getActiveBadgeVariant(tag.id)"
          @click.prevent="tagDomain(tag.id)"
        >
          {{ tag.name }}
        </b-badge>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    td: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      tagForm: false,
      tags: [
        {
          id: 'ban',
          name: 'Ban'
        },
        {
          id: 'resell',
          name: 'Re-sell'
        },
        {
          id: 'whitelist',
          name: 'Whitelist'
        },
        {
          id: 'dsp',
          name: 'DSP'
        }
      ]
    };
  },

  methods: {
    openForm() {
      this.tagForm = true;
    },

    closeForm() {
      this.tagForm = false;
    },

    getActiveBadgeVariant(tag) {
      return tag === this.data.group.tag ? this.getBadgeVariant(tag) : 'light';
    },

    getBadgeVariant(tag) {
      switch (tag) {
        case 'ban':
          return 'danger';
        case 'resell':
          return 'warning';
        case 'dsp':
          return 'success';
        default:
          return 'info';
      }
    },

    setTagForm(name) {
      this.tagForm = name;
    },

    tagDomain(tag) {
      this.$api.core
        .post('/domain/tag', {
          domain: this.data.group.title,
          tag
        })
        .then(res => {
          if (res.error) return Promise.reject(res);

          this.data.group.tag = tag;

          this.$notify('alert', {
            text: `Domain ${this.data.group.title} has been tagged as ${tag}`,
            variant: 'success',
            time: 5000
          });
        })
        .catch(res => {
          this.$notify('alert', {
            text: res.error.message || this.$t('somethingWentWrong'),
            variant: 'danger',
            time: 5000
          });
        });
    }
  }
};
</script>

<style lang="scss">
.badge {
  font-size: 0.74rem;
  text-transform: capitalize;
}

.tag-form {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  height: 100%;
  background-color: $table-bg;
  border-left: 1px solid $border-color;

  .badge {
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }

  &-close {
    position: absolute;
    right: 8px;
    color: inherit;
    cursor: pointer;
  }
}
</style>
